import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
	name: 'confirm-line-haul-connection',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			hubName: "",
			showTable: false,
			isLoadingSearch: false,
			isLoading: false,
			isDisplay: true,
			bagNumber: "", //xb-vadodara8
			bagDetails: {
				bagno: "",
				noofbags: "",
				noofshipments: "",
				physicalweight: "",
				volumetricweight: "",
			},
			ConfirmBagShortage: false
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.getHubName(userdetail[0].HubId);

	},
	methods: {
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},

		loadBagDetails() {
			this.isLoadingSearch = true
			this.input = {}
			axios({
					method: 'GET',
					'url': apiUrl.allocateRuleapi_url + 'getComboHubBagDetailsForBagShortage?BagNo=' + this.bagNumber,
					'data': this.input,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.showTable = true;
							this.bagDetails = response.ResponseData[0];
						}
					} else {
						this.bagDetails = {};
						this.isLoadingSearch = false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
					this.isLoading = false
				}, error => {
					this.isDisplay = false
					this.isLoading = false
					var code = error.response == undefined ? code = 0 : error.response.status;
					if (code == 500) {
						this.$alertify.error(error.response.statusText);
					} else {
						this.$alertify.error(error.response.statusText);
					}
					console.log(error)
				})
		},
		ConfirmBagShortageMark() {
			this.ConfirmBagShortage = true;
		},
		CloseConfirmation() {
			this.ConfirmBagShortage = false;
		},
		MarkBagInvalid(bagDetails) {
			this.input = ({
				"currentHubId": this.hubId,
				"currentHubName": this.hubName,
				"reason": "Combo Hub Bag Shortage Mark",
				"parentBagNo": bagDetails.bagno,
				"lastModifiedBy": this.useremail
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'markComboHubBagShortage',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						this.ConfirmBagShortage = false;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.ConfirmBagShortage = false;

					}
				}, error => {
					console.error(error)
				})
		},
		 onSubmitSearch: function() {
		 this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				else{
					this.loadBagDetails()
				}
				}).catch(() => {
					console.log('errors exist')
			});
		},

		resetForm() {
			this.bagNumber = "";
			this.bagDetails = {};
			this.isLoadingSearch = false;
			this.showTable = false;
			this.$validator.reset();
			this.errors.clear();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ComboHubBagShortageMark/ComboHubBagShortageMark.js